import { render } from "./Tags.vue?vue&type=template&id=64df7e42&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=64df7e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64df7e42"]])

export default __exports__